export const TrelloIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <rect fill="#0079bf" x="4" y="4" width="40" height="40" rx="4" />
    <rect fill="#fff" x="8" y="8" width="14" height="28" rx="2" />
    <rect fill="#fff" x="26" y="8" width="14" height="18" rx="2" />
  </svg>
);
